import Navbar from "../components/Navbar";
import Body from "../components/Body";
import Footer from "../components/footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
function Home() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <>
      <div style={{ overflowX: "hidden" }}>
        <Navbar />
        <Body />
        <Footer />
      </div>
    </>
  );
}

export default Home;
